import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Cal, { getCalApi } from "@calcom/embed-react";

const CAL_LINK = "diego-bello-wjxsik/black-belts-ai";

export const BookingModal = ({ open, onClose }) => {
  useEffect(() => {
    (async () => {
      const cal = await getCalApi({ namespace: "black-belts" });
      cal("ui", {
        theme: "dark",
        cssVarsPerTheme: {
          dark: {
            "cal-bg": "#0a0a0a",
            "cal-bg-emphasis": "#121212",
            "cal-bg-muted": "#0a0a0a",
            "cal-border": "rgba(232,228,217,0.12)",
            "cal-border-subtle": "rgba(232,228,217,0.06)",
            "cal-text": "#E8E4D9",
            "cal-text-emphasis": "#E8E4D9",
            "cal-text-muted": "#A3A097",
            "cal-brand": "#0E9B6A",
            "cal-brand-emphasis": "#34D399",
            "cal-brand-text": "#050505",
          },
        },
        hideEventTypeDetails: false,
        layout: "month_view",
      });
    })();
  }, []);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.35 }}
          className="fixed inset-0 z-[200] flex items-center justify-center p-3 md:p-8"
          data-testid="booking-modal"
        >
          <div
            className="absolute inset-0 bg-black/85 backdrop-blur-2xl"
            onClick={onClose}
          />
          <motion.div
            initial={{ opacity: 0, y: 30, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.98 }}
            transition={{ duration: 0.55, ease: [0.16, 1, 0.3, 1] }}
            className="relative w-full max-w-[1100px] max-h-[92vh] bg-[var(--bb-bg-2)] border border-[var(--bb-border-strong)] flex flex-col overflow-hidden"
          >
            <div className="flex items-start justify-between px-6 md:px-10 py-5 border-b border-[var(--bb-border)] gap-4">
              <div>
                <div className="mono-label text-[var(--bb-copper)] mb-2">
                  [ AGENDA · BLACK BELTS AI ]
                </div>
                <h3 className="font-display text-xl md:text-3xl leading-tight tracking-[-0.02em]">
                  Agenda tu{" "}
                  <span className="font-serif-italic text-[var(--bb-copper-light)]">
                    reunión.
                  </span>
                </h3>
              </div>
              <button
                type="button"
                onClick={onClose}
                className="w-10 h-10 border border-[var(--bb-border-strong)] flex items-center justify-center hover:border-[var(--bb-copper)] transition-colors shrink-0"
                aria-label="cerrar"
                data-testid="booking-close"
              >
                <span className="text-xl leading-none">×</span>
              </button>
            </div>

            <div
              className="flex-1 overflow-y-auto bg-[var(--bb-bg-2)]"
              data-testid="booking-cal-wrapper"
            >
              <Cal
                namespace="black-belts"
                calLink={CAL_LINK}
                style={{
                  width: "100%",
                  height: "100%",
                  minHeight: "620px",
                  overflow: "scroll",
                }}
                config={{ layout: "month_view", theme: "dark" }}
              />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
